'use client'

import { Card } from '@morpho-org/ui-v6/server'

import type { MarketIrm } from '@/lib/procedures/marketIrm.contract'

import InterestRateModelChart from '@/components/charts/components/InterestRateModelChart'

export interface ChartInterestRateModelClientProps {
  irm: MarketIrm
}

const ChartInterestRateModelClient = ({ irm }: ChartInterestRateModelClientProps) => {
  return (
    <Card className="grow" padding="s" withBorder>
      <InterestRateModelChart
        statuses={{ loading: false, error: false }}
        height="288px"
        data={irm.curve}
        irmAddress={irm.irmAddress}
        utilization={irm.utilization}
      />
    </Card>
  )
}

export default ChartInterestRateModelClient
